import React, { Component } from 'react';
import { Grid, Input } from 'semantic-ui-react';
import { decamelize } from './util';
import _ from 'lodash';

export default class AdCvdOutput extends Component {    
    constructor(props) {
        super(props);
        this.state = {
            "caseType": null
        }
    }
    detailedCase = (e) => {
        let caseType = e.target.dataset.casetype;
        if(caseType !== this.state.caseType){
            this.setState({"caseType": caseType});
        }else{
            this.setState({"caseType": null});
        }
    }

    onSearch = (e) => {
        if(e.which === 13){
            let str = e.target.value;
            if (window.find) {
                // CODE FOR BROWSERS THAT SUPPORT window.find
                let strFound=window.find(str);
                if (!strFound) {
                    strFound=window.find(str,0,1);
                    while (window.find(str,0,1)) continue;
                }
            }
        }
    }
    render() {
        const {qryOutput} =  this.props;
        const result = qryOutput.responseParams;
        return (
            <div id='AdCvdOutput' className={`outputData adcvdOutput`}>
                <Grid className={`adcvdCaseList`}>
                    {
                        (result.cases||[]).map((item, index) => (
                             <React.Fragment>
                            <Grid.Row className={`adcvd-row`} columns={3}>
                                <Grid.Column width={12}>
                                    <Grid>
                                        <Grid.Row className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                            <Grid.Column className="keyName" width={5}>Case Number</Grid.Column>
                                            <Grid.Column width={1}></Grid.Column>
                                            <Grid.Column className="keyValue" width={10}>{item.caseNo ? item.caseNo : 'NA'}</Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                            <Grid.Column className="keyName" width={5}>Manufacturer Name</Grid.Column>
                                            <Grid.Column width={1}></Grid.Column>
                                            <Grid.Column className="keyValue" width={10}>{item.manufacturerName ? item.manufacturerName : 'NA'}</Grid.Column>
                                        </Grid.Row> 
                                        <Grid.Row className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                            <Grid.Column className="keyName" width={5}>Ad Valorem Rate</Grid.Column>
                                            <Grid.Column width={1}></Grid.Column>
                                            <Grid.Column className="keyValue" width={10}>{item.adValoremRate ? item.adValoremRate : 'NA'}</Grid.Column>
                                        </Grid.Row> 
                                        <Grid.Row className={`adcvd-casenumber-row`} columns={3}>
                                            <Grid.Column className="keyName" width={5}>Cash Bond Indicator</Grid.Column>
                                            <Grid.Column width={1}></Grid.Column>
                                            <Grid.Column className="keyValue" width={10}>{item.cashBondIndicator ? item.cashBondIndicator : 'NA'}</Grid.Column>
                                        </Grid.Row>   
                                    </Grid>    
                                </Grid.Column>
                                <Grid.Column width={1}></Grid.Column>
                                <Grid.Column width={3}>
                                <Grid>
                                    <Grid.Row className={`detailbtn-row`}>
                                        <Grid.Column>
                                        <span className={`btn runAgainBtn`} data-caseType={`CASE_${index}`} style={{"width":"112px"}} onClick={this.detailedCase}>Details</span>
                                        </Grid.Column>
                                    </Grid.Row>
                                    <Grid.Row className={`selectcasebtn-row`}>
                                        <Grid.Column>
                                        {
                                            this.props.selectCase && 
                                            <span className={`btn runAgainBtn`} style={{"width":"112px"}} onClick={()=>{
                                                // debugger;
                                                this.props.selectCase({
                                                    "caseData": {
                                                        "adValoremRate": item.adValoremRate || "",
                                                        "caseNo": item.caseNo || "",
                                                        "cashBondIndicator": item.cashBondIndicator || ""
                                                    }
                                                })
                                                this.props.closeModal()
                                            }}>Select Case</span>
                                        }    
                                        </Grid.Column>
                                    </Grid.Row>
                                </Grid>
                                </Grid.Column>
                            </Grid.Row>
                            {
                                // <Grid.Row className={`adcvd-casenumber-row-header ${(this.state.caseType == 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={3}>
                                //     <Grid.Column className="keyName" width={8}></Grid.Column>
                                //     <Grid.Column width={5}>
                                //         <Input type='search' onKeyPress={this.onSearch} name='searchData'/><i class="search icon"></i>
                                //     </Grid.Column>
                                //     <Grid.Column width={3}><div className={`btn runAgainBtn`}>Select Query</div></Grid.Column>
                                // </Grid.Row> 
                            }
                            {
                                (item.detail && item.detail.records && !_.isEmpty(item.detail.records[0])) ? item.detail.records.map((_item, _index) => (
                                    <Grid.Row id={`CASE_ROW_${index}`} className={`adcvd-detailed-casenumber-row ${(this.state.caseType === 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={2}>
                                        <Grid.Column width={16}>
                                            <Grid>
                                                <Grid.Row className={`adcvd-casenumber-row blueBorder bottom`} columns={1}>
                                                    <Grid.Column className="caseTypeHeading">{_item.name} </Grid.Column>
                                                </Grid.Row>
                                                {
                                                    _item.values && _item.values.map((__item, __index) => (
                                                        <Grid.Row className={`adcvd-casenumber-row bottom-border`} columns={3}>
                                                            <Grid.Column className="keyName" width={5}>{decamelize(__item.key)}</Grid.Column>
                                                            <Grid.Column width={1}></Grid.Column>
                                                            <Grid.Column className="keyValue" width={10}>{__item.value}</Grid.Column>
                                                        </Grid.Row>
                                                    ))
                                                }
                                            </Grid>    
                                        </Grid.Column>
                                    </Grid.Row>
                                )) :  <Grid.Row id={`CASE_ROW_${index}`} className={`adcvd-detailed-casenumber-row ${(this.state.caseType == 'CASE_'+index)? 'showCase': 'hideCase'}`} columns={1}>
                                    <Grid.Column style={{"textAlign":"center", "marginTop": "20px", "fontWeight": "bold", "width": "100%"}}>Not a valid Detail</Grid.Column>
                                    </Grid.Row>
                            }
                             </React.Fragment>
                        ))  
                    }
                </Grid>
            </div>
        )
    }
}